import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs";

export enum IconBarPolicy {
  Toggleable = 'toggleable',
  ForcedVisible = 'forcedVisible'
}

@Injectable({
  providedIn: 'root'
})
export class IconBarService {
  public iconBarVisible: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public iconBarPolicy: BehaviorSubject<IconBarPolicy> = new BehaviorSubject<IconBarPolicy>(IconBarPolicy.Toggleable);

  public toggleIconBar(): void {
    if (this.iconBarPolicy.value === IconBarPolicy.ForcedVisible) {
      return;
    }
    this.iconBarVisible.next(!this.iconBarVisible.value);
  }

  public setIconBarPolicy(policy: IconBarPolicy): void {
    this.iconBarPolicy.next(policy);
    if (policy === IconBarPolicy.ForcedVisible && !this.iconBarVisible.value) {
      this.iconBarVisible.next(true);
    }
  }

}
